export default {
  // 模块名称
  reserveImplement: {
    // 按钮类
    button: {
      response: 'response'
    },
    // 文字标签类
    label: {
      position: 'Alarm position',
      manualReserve: 'Manual reserve',
      reselect: 'Reselect',
      alarmType: 'Alarm type',
      deviceSelect: 'Device select',
      reserveSelect: 'Reserve select'
    },
    // 提示类
    placeholder: {
      reserveDesc: 'Please input reserve details',
    },
    // 消息类
    message: {
      noVideo: 'There is no video, you have not choose area',
      clickMap: 'Please map to choose',
      noReserve: 'You have not choose area',
      choose: 'Click to choose'
    },
    // 标题类
    title: {
      alarmDesc: 'Alarm details',
      reserveDesc: 'Reserve details',
      reserveSteps: 'Reserve steps',
      manualReserve: 'Manual reserve',
      alarmReserve: 'Alarm reserve'
    }
  }
}
